import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { sendError } from '../sendError';
import { traceHeaderName } from '../interfaces/serverTokens';
import { defaultLocale as defaultLanguage } from '@pec/aion-ui-i18next/constants';
import i18next from 'i18next';

export const registerOrganizationIdInterceptor = (organizationId: string) => {
  axios.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      config.headers['X-Aion-OrganizationId'] =
        (config.headers && config.headers['X-Aion-OrganizationId']) || organizationId;
      return config;
    },
    (error: AxiosError) => sendError(error)
  );
};

export const registerAcceptLanguageInterceptor = () => {
  axios.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      config.headers['Accept-Language'] = i18next.language || defaultLanguage;
      return config;
    },
    (error: AxiosError) => sendError(error)
  );
};

export const registerBearerTokenInterceptor = (accessToken: string, onRejected: (error: AxiosError) => void) => {
  axios.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      config.headers.common.Authorization = `Bearer ${accessToken}`;
      return config;
    },
    (error: AxiosError) => onRejected(error)
  );
};

export const registerTraceHeaderInterceptor = (traceHeaderValue: string) =>
  axios.interceptors.request.use(
    config => {
      config.headers.common[traceHeaderName] = traceHeaderValue;
      return config;
    },
    error => console.error(error)
  );
